import styled from 'styled-components';
import { Avatar as AvatarBase, Tooltip } from '@mui/material';
import { mapNameToColor, getFirstLettersOfName } from '../../utils/common';

type Size = 'extraSmall' | 'small' | 'medium' | 'large';

const AvatarStyled = styled(AvatarBase)<{
  $size: Size;
}>`
  font-weight: ${({ theme }) => theme.typography.fontWeightBold};
  color: ${({ theme }) => theme.palette.common.white};

  ${({ $size }) =>
    $size === 'extraSmall'
      ? `
      width: 16px;
      height: 16px;
      font-size: 8px;
      `
      : $size === 'small'
      ? `
      width: 20px;
      height: 20px;
      font-size: 9px;
      `
      : $size === 'medium'
      ? `
      width: 22px;
      height: 22px;
      font-size: 10px;
      `
      : $size === 'large'
      ? `
      width: 32px;
      height: 32px;
      font-size: 12px;
      `
      : `
      width: 22px;
      height: 22px;
      font-size: 10px;
      `}
`;

type Props = {
  value: { id?: string; name: string };
  tooltip?: string;
  size?: 'extraSmall' | 'small' | 'medium' | 'large';
};

const Avatar = ({ value, tooltip, size = 'medium' }: Props) => (
  <Tooltip title={tooltip}>
    <AvatarStyled
      sx={{ background: mapNameToColor(value.id || value.name) }}
      $size={size}
    >
      {getFirstLettersOfName(value.name)}
    </AvatarStyled>
  </Tooltip>
);

export default Avatar;
